import tw, { styled } from 'twin.macro';

const Subtitle = styled.p(({ variant = 'default', color }) => [
  tw`font-primary tracking-wider text-black leading-6`,
  variant === 'default' && tw`text-base`, // 18px
  variant === 'small' && tw`text-sm`, // 14px
  variant === 'extraSmall' && tw` text-xs`, // 12px
  variant === 'large' && tw` text-xl`, // 20px
  color === 'white' && tw` text-white`,
  color === 'light' && tw`text-gray-light`,
  color === 'dark' && tw`text-gray`,
]);

export default Subtitle;
